import { CheckCircle, FilePlus, Trash } from "react-feather";
import { Nav, NavItem } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { AllTask, Href, ToDoList,TrashBin} from "../../../Constant";
import { WorkingTabs } from "./WorkingTabs";

export const SideBarNavItem = () => {
  return (
    <Nav className="main-menu">
      <NavItem>
        <Btn color="primary" className="d-block btn-mail w-100">
          <CheckCircle className="me-2" />
          {ToDoList}
        </Btn>
      </NavItem>
      <NavItem>
        <a href={Href}>
          <span className="iconbg bg-light-primary">
            <FilePlus className="stroke-primary" />
          </span>
          <span className="title ms-2">{AllTask}</span>
        </a>
      </NavItem>
      <WorkingTabs />
      <NavItem>
        <a href={Href}>
          <span className="iconbg bg-light-danger">
            <Trash className="stroke-danger" />
          </span>
          <span className="title ms-2">{TrashBin}</span>
        </a>
      </NavItem>
    </Nav>
  );
};
